import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 18 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.543 3.029a.991.991 0 0 1 1.381 0 .935.935 0 0 1 0 1.353l-8.223 8.045-1.383-1.351 8.225-8.047Zm2.647 2.59a2.662 2.662 0 0 0 0-3.828 2.812 2.812 0 0 0-3.912 0l-9.489 9.284 3.912 3.827 9.489-9.283ZM.31 15.324l2.594-2.733a.09.09 0 0 1 .127.002l2.875 2.875a.064.064 0 0 1-.004.095l-1.288.833c-.33.23-.726.354-1.13.354H1.001c-.915 0-1.336-.791-.692-1.426Z"
      />
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
